import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, Button } from '@avangard/ui/core';

import type { DialogProps } from '@avangard/ui/core';

type DialogLectureDeleteProps = Pick<DialogProps, 'disabled' | 'onAccept'>;

const DialogLectureDelete = (props: DialogLectureDeleteProps): React.ReactElement => {
    const { t } = useTranslation(['subjects']);

    return (
        <Dialog
            title={t('subjects:remove_lecture.title')}
            content={t('subjects:remove_lecture.confirm')}
            {...props}
        >
            {dialogProps => {
                const { handleOpen } = dialogProps;

                return (
                    <Button variant='outlined' onClick={handleOpen}>
                        {t('subjects:actions.remove_lecture')}
                    </Button>
                );
            }}
        </Dialog>
    );
};

export { DialogLectureDelete };
